import * as Icons from '../constants/icons';

import { EslStatistic } from '../statistics/eslStatistic';
import Layout from '../components/layout';
import React from 'react';
import SEO from '../components/seo';
import { canvas } from 'leaflet';
import headerImage from '../images/banner/banner-4.jpg';

const TheESL = () => {
    return (
        <Layout headerTitle="Emergency Services Levy Collections and Allocations" headerImage={headerImage} showCTA={true}>
            <SEO title="Emergency Services Levy Collections and Allocations" />
            <div className="o-container ">
                <div className="o-section o-section--md o-section--pt-only">
                    <p>
                        DFES charges for services rendered on a partial cost recovery basis. Pursuant to Section 36G(3) of the Fire and
                        Emergency Services Act 1998 the current list of fees and charges were published in the Government Gazette on 15 June
                        2021 and payable from 1 July 2021. Details are available in Table 2 below.
                    </p>

                    <p>
                        In 2020-21, the Emergency Services Levy (ESL) raised $345 million from ratepayers, $4 million from local government
                        owned properties and $23 million from the State Government and non-trading State enterprises.
                    </p>

                    <p>
                        The amount of ESL raised was significantly less than last year as a result of COVID 19 relief measures introduced by
                        the State Government to reduce household fees and charges. The reduction in ESL revenue was offset by $40 million of
                        direct funding provided by the State Government. As a result, activities that were previously fully funded through
                        the ESL, were funded by a mix of ESL and State Government appropriations in 2020-21.
                    </p>
                </div>
            </div>

            <div className="o-container">
                <div className="o-section o-section--sm">
                    <h2 className="section-title">Our major services and activities</h2>
                    <p>In 2020-21, ESL was used to fund the major services and activities:</p>
                    <div className="uk-grid-medium uk-child-width-1-2@s uk-child-width-1-3@m uk-grid">
                        <EslStatistic
                            description="Employed personnel in fire stations across Perth, Albany, Bunbury, Geraldton and Kalgoorlie who are response ready for a variety of emergency situations, 24/7."
                            value="$122 million"
                            label="Career Fire and Rescue Service"
                            icon={<Icons.ESL_Firefighters />}
                        />
                        <EslStatistic
                            description="The committed volunteers in towns and built-up areas who provide an emergency response when it is needed most."
                            value="$15 million"
                            label="Volunteer Fire and Rescue/ Fire and Emergency Services"
                            icon={<Icons.ESL_VolunteerHead />}
                        />
                        <EslStatistic
                            description="The dedicated volunteers who protect us from bushfires through fire suppression, prevention and risk management services and fire safety education in rural and pastoral areas."
                            value="$31 million"
                            label="Bush Fire Service"
                            icon={<Icons.ESL_Firehouse />}
                        />
                        <EslStatistic
                            description="The steadfast volunteers in orange who provide help to the community in a variety of situations such as severe weather and search and rescue operations."
                            value="$9 million"
                            label="State Emergency Services"
                            icon={<Icons.ESL_House />}
                        />
                        <EslStatistic
                            description="The devoted volunteers along our coastline who protect and save lives at sea."
                            value="$9 million"
                            label="Marine Rescue Western Australia"
                            icon={<Icons.ESL_Ship />}
                        />
                        <EslStatistic
                            description="Improving rural fire management through increased investment in mitigation, strengthening relationships with volunteers, and greater collaboration between agencies."
                            value="$14 million"
                            label="Rural Fire Division"
                            icon={<Icons.ESL_Fire />}
                        />
                        <EslStatistic
                            description="Providing professional development for volunteers and career personnel to enhance their operational and organisational skills."
                            value="$28 million"
                            label="Emergency Services Training"
                            icon={<Icons.ESL_Checklist />}
                        />
                        <EslStatistic
                            description="Operation and coordination of the aerial fleet that is deployed rapidly to emergency incidents, protecting lives and property during the bushfire season."
                            value="$14 million"
                            label="Aerial Firefighting and Aviation Services"
                            icon={<Icons.ESL_Helicopter />}
                        />
                        <EslStatistic
                            description="Includes construction of fire stations and other facilities as well as maintenance, improvement and replacement of facilities, response vehicles and equipment."
                            value="$66 million"
                            label="Asset Construction and Maintenance"
                            icon={<Icons.ESL_Extinguisher />}
                        />
                        <EslStatistic
                            description="Working with communities and local governments to strengthen relationships with our volunteers."
                            value="$2 million"
                            label="Volunteer Engagement"
                            icon={<Icons.ESL_Community />}
                        />
                        <EslStatistic
                            value="$8 million"
                            label="Emergency Management, Strategy and Planning"
                            icon={<Icons.ESL_Document />}
                            description="Research and planning activities to improve our services and inform decisions on how we allocate our resources."
                        />
                        <EslStatistic
                            description="Enhancing psychological and physical wellbeing for emergency services employees, volunteers and their families."
                            value="$3 million"
                            label="Health and Wellness"
                            icon={<Icons.ESL_Wellbeing />}
                        />
                        <EslStatistic
                            description="Determining the cause of fires and ensuring compliance with relevant standards to reduce the frequency and impact of emergency incidents."
                            value="$4 million"
                            label="Investigation and Compliance"
                            icon={<Icons.ESL_Checklist />}
                        />
                        <EslStatistic
                            description="Includes the running of emergency operations centres and the ‘000’ communications centre to dispatch and coordinate emergency responses."
                            value="$10 million"
                            label="Emergency Response Coordination"
                            icon={<Icons.ESL_Phone />}
                        />
                        <EslStatistic
                            description="Improving and maintaining the technology and communications infrastructure behind all our emergency services."
                            value="$24 million"
                            label="Technology and Communications"
                            icon={<Icons.ESL_Technology />}
                        />
                        <EslStatistic
                            description="Upskilling personnel and maintaining specialist equipment to enhance our emergency response across a range of events such as hazardous material spills and building collapse."
                            value="$4 million"
                            label="Special Operations"
                            icon={<Icons.ESL_Alert />}
                        />
                        <EslStatistic
                            description="Providing information and programs to communities to increase awareness and build a more resilient and safer State."
                            value="$14 million"
                            label="Community Awareness and Education"
                            icon={<Icons.ESL_Community />}
                        />
                    </div>
                    <p>
                        The table above shows only the ESL allocated to each service and excludes expenditure funded from other sources. The
                        total ESL expended in 2020-21 was $6 million more than the amount raised, primarily due to the capital works
                        projects funded from ESL collected in prior years. Figures have been rounded to the nearest million and include an
                        allocation of indirect expenditure of $19 million on a weighted average basis.
                    </p>
                </div>
            </div>

            {/* <div className="o-container">
                <div className="o-section o-section--sm">
                    <h2 className="section-title">Grants</h2>
                    <table className="table-striped table-responsive">
                        <thead>
                            <tr>
                                <th style={{ width: '60%' }}>Grant Recipient</th>
                                <th className="u-text-right">Operating&nbsp;$'000</th>
                                <th className="u-text-right">Capital&nbsp;$'000</th>
                                <th className="u-text-right">Total&nbsp;$'000</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    Local Government Grant Scheme – Bush Fire Service<sup>1</sup>
                                </td>
                                <td className="u-text-right">9,011</td>
                                <td className="u-text-right">7,682</td>
                                <td className="u-text-right">16,693</td>
                            </tr>
                            <tr>
                                <td>
                                    Local Government Grant Scheme – State Emergency Services<sup>1</sup>
                                </td>
                                <td className="u-text-right">1,865</td>
                                <td className="u-text-right">171</td>
                                <td className="u-text-right">2,036</td>
                            </tr>
                            <tr>
                                <td>Community Emergency Services Managers</td>
                                <td className="u-text-right">2,121</td>
                                <td className="u-text-right">-</td>
                                <td className="u-text-right">2,121</td>
                            </tr>
                            <tr>
                                <td>Volunteer Marine Rescue Services</td>
                                <td className="u-text-right">2,136</td>
                                <td className="u-text-right">4,461</td>
                                <td className="u-text-right">6,597</td>
                            </tr>
                            <tr>
                                <td>Grants to volunteer entities</td>
                                <td className="u-text-right">843</td>
                                <td className="u-text-right">-</td>
                                <td className="u-text-right">843</td>
                            </tr>
                            <tr>
                                <td>Grants to volunteer representative bodies</td>
                                <td className="u-text-right">770</td>
                                <td className="u-text-right">-</td>
                                <td className="u-text-right">770</td>
                            </tr>
                            <tr>
                                <td>Private brigades</td>
                                <td className="u-text-right">182</td>
                                <td className="u-text-right">-</td>
                                <td className="u-text-right">182</td>
                            </tr>
                            <tr>
                                <td>Bushfire Risk Management Planning</td>
                                <td className="u-text-right">2,082</td>
                                <td className="u-text-right">-</td>
                                <td className="u-text-right">2,082</td>
                            </tr>
                            <tr>
                                <td>Mitigation</td>
                                <td className="u-text-right">1,631</td>
                                <td className="u-text-right">-</td>
                                <td className="u-text-right">1,631</td>
                            </tr>
                            <tr>
                                <td>ChemCentre Hazardous Materials Emergency Response</td>
                                <td className="u-text-right">1,355</td>
                                <td className="u-text-right">-</td>
                                <td className="u-text-right">1,355</td>
                            </tr>
                            <tr>
                                <td>Other</td>
                                <td className="u-text-right">372</td>
                                <td className="u-text-right">-</td>
                                <td className="u-text-right">372</td>
                            </tr>
                            <tr>
                                <td>Total</td>
                                <td className="u-text-right">
                                    <strong>22,367</strong>
                                </td>
                                <td className="u-text-right">
                                    <strong>12,314</strong>
                                </td>
                                <td className="u-text-right">
                                    <strong>34,681</strong>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p>
                        In 2020-21, grants that were previously fully funded through the ESL were funded by a mix of ESL and State
                        Government appropriations. The table above shows only the ESL funding portion allocated to these programs.
                    </p>
                </div>
            </div> */}

            <div className="o-container">
                <div className="o-section o-section--sm">
                    <h2 className="section-title">Table 2: 2020-21 ESL Raised by Local Government Area</h2>
                    <h5>ESL Collected</h5>
                    <p>
                        The table below shows the ESL raised within each local government area. Please note that it does not include ESL
                        raised in relation to property owned by the State Government and non-trading State enterprises.
                    </p>
                    <table className="table-striped table-responsive --lga">
                        <thead>
                            <tr>
                                <th style={{ width: '60%' }}>Local Government Area</th>
                                <th>ESL Raised ($'000s)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Albany</td>
                                <td>3,567</td>
                            </tr>
                            <tr>
                                <td>Armadale</td>
                                <td>9,524</td>
                            </tr>
                            <tr>
                                <td>Ashburton</td>
                                <td>403</td>
                            </tr>
                            <tr>
                                <td>Augusta-Margaret River</td>
                                <td>999</td>
                            </tr>
                            <tr>
                                <td>Bassendean</td>
                                <td>2,380</td>
                            </tr>
                            <tr>
                                <td>Bayswater</td>
                                <td>9,697</td>
                            </tr>
                            <tr>
                                <td>Belmont</td>
                                <td>8,463</td>
                            </tr>
                            <tr>
                                <td>Beverley</td>
                                <td>124</td>
                            </tr>
                            <tr>
                                <td>Boddington</td>
                                <td>105</td>
                            </tr>
                            <tr>
                                <td>Boyup Brook</td>
                                <td>115</td>
                            </tr>
                            <tr>
                                <td>Bridgetown-Greenbushes</td>
                                <td>293</td>
                            </tr>
                            <tr>
                                <td>Brookton</td>
                                <td>62</td>
                            </tr>
                            <tr>
                                <td>Broome</td>
                                <td>1,108</td>
                            </tr>
                            <tr>
                                <td>Broomehill-Tambellup</td>
                                <td>69</td>
                            </tr>
                            <tr>
                                <td>Bruce Rock</td>
                                <td>66</td>
                            </tr>
                            <tr>
                                <td>Bunbury</td>
                                <td>4,709</td>
                            </tr>
                            <tr>
                                <td>Busselton</td>
                                <td>2,587</td>
                            </tr>
                            <tr>
                                <td>Cambridge</td>
                                <td>5,569</td>
                            </tr>
                            <tr>
                                <td>Canning</td>
                                <td>17,639</td>
                            </tr>
                            <tr>
                                <td>Capel</td>
                                <td>1,061</td>
                            </tr>
                            <tr>
                                <td>Carnamah</td>
                                <td>46</td>
                            </tr>
                            <tr>
                                <td>Carnarvon</td>
                                <td>280</td>
                            </tr>
                            <tr>
                                <td>Chapman Valley</td>
                                <td>76</td>
                            </tr>
                            <tr>
                                <td>Chittering</td>
                                <td>239</td>
                            </tr>
                            <tr>
                                <td>Claremont</td>
                                <td>2,773</td>
                            </tr>
                            <tr>
                                <td>Cockburn</td>
                                <td>17,565</td>
                            </tr>
                            <tr>
                                <td>Collie</td>
                                <td>421</td>
                            </tr>
                            <tr>
                                <td>Coolgardie</td>
                                <td>250</td>
                            </tr>
                            <tr>
                                <td>Coorow</td>
                                <td>101</td>
                            </tr>
                            <tr>
                                <td>Corrigin</td>
                                <td>77</td>
                            </tr>
                            <tr>
                                <td>Cottesloe</td>
                                <td>1,746</td>
                            </tr>
                            <tr>
                                <td>Cranbrook</td>
                                <td>74</td>
                            </tr>
                            <tr>
                                <td>Cuballing</td>
                                <td>58</td>
                            </tr>
                            <tr>
                                <td>Cue</td>
                                <td>37</td>
                            </tr>
                            <tr>
                                <td>Cunderdin</td>
                                <td>86</td>
                            </tr>
                            <tr>
                                <td>Dalwallinu</td>
                                <td>90</td>
                            </tr>
                            <tr>
                                <td>Dandaragan</td>
                                <td>335</td>
                            </tr>
                            <tr>
                                <td>Dardanup</td>
                                <td>682</td>
                            </tr>
                            <tr>
                                <td>Denmark</td>
                                <td>376</td>
                            </tr>
                            <tr>
                                <td>Derby-West Kimberley</td>
                                <td>237</td>
                            </tr>
                            <tr>
                                <td>Donnybrook-Balingup</td>
                                <td>306</td>
                            </tr>
                            <tr>
                                <td>Dowerin</td>
                                <td>50</td>
                            </tr>
                            <tr>
                                <td>Dumbleyung</td>
                                <td>48</td>
                            </tr>
                            <tr>
                                <td>Dundas</td>
                                <td>82</td>
                            </tr>
                            <tr>
                                <td>East Fremantle</td>
                                <td>1,377</td>
                            </tr>
                            <tr>
                                <td>East Pilbara</td>
                                <td>410</td>
                            </tr>
                            <tr>
                                <td>Esperance</td>
                                <td>804</td>
                            </tr>
                            <tr>
                                <td>Exmouth</td>
                                <td>231</td>
                            </tr>
                            <tr>
                                <td>Fremantle</td>
                                <td>8,049</td>
                            </tr>
                            <tr>
                                <td>Gingin</td>
                                <td>481</td>
                            </tr>
                            <tr>
                                <td>Gnowangerup</td>
                                <td>79</td>
                            </tr>
                            <tr>
                                <td>Goomalling</td>
                                <td>63</td>
                            </tr>
                            <tr>
                                <td>Gosnells</td>
                                <td>13,655</td>
                            </tr>
                            <tr>
                                <td>Greater Geraldton</td>
                                <td>3,453</td>
                            </tr>
                            <tr>
                                <td>Halls Creek</td>
                                <td>80</td>
                            </tr>
                            <tr>
                                <td>Harvey</td>
                                <td>1,249</td>
                            </tr>
                            <tr>
                                <td>Irwin</td>
                                <td>245</td>
                            </tr>
                            <tr>
                                <td>Jerramungup</td>
                                <td>104</td>
                            </tr>
                            <tr>
                                <td>Joondalup</td>
                                <td>22,549</td>
                            </tr>
                            <tr>
                                <td>Kalamunda</td>
                                <td>6,412</td>
                            </tr>
                            <tr>
                                <td>Kalgoorlie-Boulder</td>
                                <td>3,488</td>
                            </tr>
                            <tr>
                                <td>Karratha</td>
                                <td>1,531</td>
                            </tr>
                            <tr>
                                <td>Katanning</td>
                                <td>212</td>
                            </tr>
                            <tr>
                                <td>Kellerberrin</td>
                                <td>78</td>
                            </tr>
                            <tr>
                                <td>Kent</td>
                                <td>40</td>
                            </tr>
                            <tr>
                                <td>Kojonup</td>
                                <td>108</td>
                            </tr>
                            <tr>
                                <td>Kondinin</td>
                                <td>63</td>
                            </tr>
                            <tr>
                                <td>Koorda</td>
                                <td>36</td>
                            </tr>
                            <tr>
                                <td>Kulin</td>
                                <td>53</td>
                            </tr>
                            <tr>
                                <td>Kwinana</td>
                                <td>5,438</td>
                            </tr>
                            <tr>
                                <td>Lake Grace</td>
                                <td>94</td>
                            </tr>
                            <tr>
                                <td>Laverton</td>
                                <td>52</td>
                            </tr>
                            <tr>
                                <td>Leonora</td>
                                <td>148</td>
                            </tr>
                            <tr>
                                <td>Mandurah</td>
                                <td>8,180</td>
                            </tr>
                            <tr>
                                <td>Manjimup</td>
                                <td>540</td>
                            </tr>
                            <tr>
                                <td>Meekatharra</td>
                                <td>78</td>
                            </tr>
                            <tr>
                                <td>Melville</td>
                                <td>16,742</td>
                            </tr>
                            <tr>
                                <td>Menzies</td>
                                <td>53</td>
                            </tr>
                            <tr>
                                <td>Merredin</td>
                                <td>197</td>
                            </tr>
                            <tr>
                                <td>Mingenew</td>
                                <td>32</td>
                            </tr>
                            <tr>
                                <td>Moora</td>
                                <td>138</td>
                            </tr>
                            <tr>
                                <td>Morawa</td>
                                <td>51</td>
                            </tr>
                            <tr>
                                <td>Mosman Park</td>
                                <td>1,520</td>
                            </tr>
                            <tr>
                                <td>Mount Marshall</td>
                                <td>46</td>
                            </tr>
                            <tr>
                                <td>Mt Magnet</td>
                                <td>48</td>
                            </tr>
                            <tr>
                                <td>Mukinbudin</td>
                                <td>39</td>
                            </tr>
                            <tr>
                                <td>Mundaring</td>
                                <td>3,399</td>
                            </tr>
                            <tr>
                                <td>Murchison</td>
                                <td>5</td>
                            </tr>
                            <tr>
                                <td>Murray</td>
                                <td>851</td>
                            </tr>
                            <tr>
                                <td>Nannup</td>
                                <td>100</td>
                            </tr>
                            <tr>
                                <td>Narembeen</td>
                                <td>52</td>
                            </tr>
                            <tr>
                                <td>Narrogin</td>
                                <td>274</td>
                            </tr>
                            <tr>
                                <td>Nedlands</td>
                                <td>4,289</td>
                            </tr>
                            <tr>
                                <td>Ngaanyatjarraku</td>
                                <td>2</td>
                            </tr>
                            <tr>
                                <td>Northam</td>
                                <td>609</td>
                            </tr>
                            <tr>
                                <td>Northampton</td>
                                <td>284</td>
                            </tr>
                            <tr>
                                <td>Nungarin</td>
                                <td>19</td>
                            </tr>
                            <tr>
                                <td>Peppermint Grove</td>
                                <td>411</td>
                            </tr>
                            <tr>
                                <td>Perenjori</td>
                                <td>39</td>
                            </tr>
                            <tr>
                                <td>Perth</td>
                                <td>24,472</td>
                            </tr>
                            <tr>
                                <td>Pingelly</td>
                                <td>76</td>
                            </tr>
                            <tr>
                                <td>Plantagenet</td>
                                <td>308</td>
                            </tr>
                            <tr>
                                <td>Port Hedland</td>
                                <td>1,112</td>
                            </tr>
                            <tr>
                                <td>Quairading</td>
                                <td>73</td>
                            </tr>
                            <tr>
                                <td>Ravensthorpe</td>
                                <td>154</td>
                            </tr>
                            <tr>
                                <td>Rockingham</td>
                                <td>12,282</td>
                            </tr>
                            <tr>
                                <td>Sandstone</td>
                                <td>15</td>
                            </tr>
                            <tr>
                                <td>Serpentine-Jarrahdale</td>
                                <td>1,584</td>
                            </tr>
                            <tr>
                                <td>Shark Bay</td>
                                <td>66</td>
                            </tr>
                            <tr>
                                <td>South Perth</td>
                                <td>7,354</td>
                            </tr>
                            <tr>
                                <td>Stirling</td>
                                <td>35,573</td>
                            </tr>
                            <tr>
                                <td>Subiaco</td>
                                <td>4,538</td>
                            </tr>
                            <tr>
                                <td>Swan</td>
                                <td>19,785</td>
                            </tr>
                            <tr>
                                <td>Tammin</td>
                                <td>30</td>
                            </tr>
                            <tr>
                                <td>Three Springs</td>
                                <td>39</td>
                            </tr>
                            <tr>
                                <td>Toodyay</td>
                                <td>272</td>
                            </tr>
                            <tr>
                                <td>Trayning</td>
                                <td>33</td>
                            </tr>
                            <tr>
                                <td>Upper Gascoyne</td>
                                <td>9</td>
                            </tr>
                            <tr>
                                <td>Victoria Park</td>
                                <td>6,799</td>
                            </tr>
                            <tr>
                                <td>Victoria Plains</td>
                                <td>49</td>
                            </tr>
                            <tr>
                                <td>Vincent</td>
                                <td>6,975</td>
                            </tr>
                            <tr>
                                <td>Wagin</td>
                                <td>119</td>
                            </tr>
                            <tr>
                                <td>Wandering</td>
                                <td>35</td>
                            </tr>
                            <tr>
                                <td>Wanneroo</td>
                                <td>23,265</td>
                            </tr>
                            <tr>
                                <td>Waroona</td>
                                <td>253</td>
                            </tr>
                            <tr>
                                <td>West Arthur</td>
                                <td>54</td>
                            </tr>
                            <tr>
                                <td>Westonia</td>
                                <td>19</td>
                            </tr>
                            <tr>
                                <td>Wickepin</td>
                                <td>48</td>
                            </tr>
                            <tr>
                                <td>Williams</td>
                                <td>61</td>
                            </tr>
                            <tr>
                                <td>Wiluna</td>
                                <td>32</td>
                            </tr>
                            <tr>
                                <td>Wongan-Ballidu</td>
                                <td>91</td>
                            </tr>
                            <tr>
                                <td>Woodanilling</td>
                                <td>32</td>
                            </tr>
                            <tr>
                                <td>Wyalkatchem</td>
                                <td>44</td>
                            </tr>
                            <tr>
                                <td>Wyndham-East Kimberley</td>
                                <td>355</td>
                            </tr>
                            <tr>
                                <td>Yalgoo</td>
                                <td>21</td>
                            </tr>
                            <tr>
                                <td>Yilgarn</td>
                                <td>110</td>
                            </tr>
                            <tr>
                                <td>York</td>
                                <td>244</td>
                            </tr>
                            <tr>
                                <td>Total</td>
                                <td>349,536</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </Layout>
    );
};

export default TheESL;
